module.exports = __webpack_public_path__ + "static/media/oh50.8eed22a2.mp3";